/**
 * Application geometry options.
 * Automatically loaded on application initialization and available as app.metrics.
 */

'use strict';

// public
module.exports = {
    480: {
        // screen base dimension
        height: 480,
        width:  720,
        // safe zone margins
        availTop:    24,
        availBottom: 24,
        availRight:  32,
        availLeft:   48,
        // app
        grid: {
            lineSize: 5,
            lineCache: 3,
            lineCount: 7,
            size: 3,
            cache: 3
        },
        moviesGrid: {
            cache: 5,
            x: 5,
            y: 3
        },
        modal: {
            size: 9
        },
        buttonList: {
            size: 5
        },
        seasonsList: {
            size: 5
        },
        seriesList: {
            size: 7
        },
        screenList: {
            size: 4
        },
        infoSroll: {
            screen: 350,
            season: 850
        }
    },

    576: {
        // screen base dimension
        height: 576,
        width:  720,
        // safe zone margins
        availTop:    24,
        availBottom: 24,
        availRight:  26,
        availLeft:   54,
        // app
        grid: {
            lineSize: 5,
            lineCache: 3,
            lineCount: 7,
            size: 3,
            cache: 3
        },
        moviesGrid: {
            cache: 5,
            x: 5,
            y: 3
        },
        modal: {
            size: 11
        },
        buttonList: {
            size: 5
        },
        seasonsList: {
            size: 5
        },
        seriesList: {
            size: 7
        },
        screenList: {
            size: 4
        },
        infoSroll: {
            screen: 350,
            season: 850
        }
    },

    720: {
        // screen base dimension
        height: 720,
        width:  1280,
        // safe zone margins
        availTop:    30,
        availBottom: 30,
        availRight:  40,
        availLeft:   40,
        // app
        grid: {
            lineSize: 5,
            lineCache: 3,
            lineCount: 7,
            size: 3,
            cache: 3
        },
        moviesGrid: {
            cache: 5,
            x: 5,
            y: 3
        },
        modal: {
            size: 13
        },
        buttonList: {
            size: 5
        },
        seasonsList: {
            size: 5
        },
        seriesList: {
            size: 7
        },
        screenList: {
            size: 5
        },
        infoSroll: {
            screen: 440,
            season: 960
        }
    },

    1080: {
        // screen base dimension
        height: 1080,
        width:  1920,
        // safe zone margins
        availTop:    45,
        availBottom: 45,
        availRight:  60,
        availLeft:   60,
        // app
        grid: {
            lineSize: 5,
            lineCache: 3,
            lineCount: 7,
            size: 3,
            cache: 3
        },
        moviesGrid: {
            cache: 5,
            x: 5,
            y: 3
        },
        modal: {
            size: 13
        },
        buttonList: {
            size: 5
        },
        seasonsList: {
            size: 5
        },
        seriesList: {
            size: 7
        },
        screenList: {
            size: 5
        },
        infoSroll: {
            screen: 440 * 1.5,
            season: 960 * 1.5
        }
    }
};
